class Selector {
  constructor(selectorString) {
    
  }
  
  parse() {
    
  }
}

export default Selector;
